import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#010409",
  boardColor: "#0A0C10",
  cardColor: "#272B33",
  fontMainColor: "#FEFEFE",
  fontSubColor: "#9A9A9A",
  hoverFontColor: "#FEFEFE",
  hoverBgColor: "#1F1F1F",
  borderColor: "#FEFEFE",
};

export const lightTheme: DefaultTheme = {
  bgColor: "#D3D3D3",
  boardColor: "#E2E4E6",
  cardColor: "rgba( 255, 255, 255, 0.4);",
  fontMainColor: "#111111",
  fontSubColor: "#666666",
  hoverFontColor: "#666666",
  hoverBgColor: "rgba( 255, 255, 255, 0.8);",
  borderColor: "#E2E4E6",
};
